import { render } from "./UiFormDate.vue?vue&type=template&id=416780b0"
import script from "./UiFormDate.vue?vue&type=script&lang=js"
export * from "./UiFormDate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\merk\\Documents\\_kwork\\virginia79\\lk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__